import {
    DatePicker as MantineDatePicker,
    DatePickerProps as MantineDatePickerProps,
    DatePickerType,
} from '@mantine/dates';

import datePickerStyles from '../styles/DatePicker.module.css';
import {
    handleGetDayProps,
    handleGetMonthControlProps,
    handleGetYearControlProps,
} from 'components/dates/utils';

export type DatePickerProps<Type extends DatePickerType = 'default'> = MantineDatePickerProps<Type>;

export const DatePicker = <Type extends DatePickerType = 'default'>({
    type = 'default' as Type,
    ...rest
}: DatePickerProps<Type>) => {
    return (
        <MantineDatePicker
            classNames={{
                day: datePickerStyles.day,
                monthCell: datePickerStyles.monthCell,
                calendarHeaderLevel: datePickerStyles.calendarHeaderLevel,
                monthsListControl: datePickerStyles.monthsListControl,
                yearsListControl: datePickerStyles.yearsListControl,
            }}
            previousLabel="Previous"
            nextLabel="Next"
            getDayProps={handleGetDayProps}
            getYearControlProps={handleGetYearControlProps}
            getMonthControlProps={handleGetMonthControlProps}
            type={type}
            {...(rest as MantineDatePickerProps<typeof type>)}
        />
    );
};
